import { useImportedStudyStore } from '../../stores/useImportedStudyStore';
import type { ImportStudyInstanceMetadata } from './parseImportStudyDicomFiles';

export type ImportStudyDuplicateCheckResult =
  | { hasDuplicates: false; instances: ImportStudyInstanceMetadata[] }
  | { hasDuplicates: true; allDuplicates: true; duplicateStudyUIDs: string[] }
  | {
      hasDuplicates: true;
      allDuplicates: false;
      duplicateStudyUIDs: string[];
      instances: ImportStudyInstanceMetadata[];
    };

function getUniqueStudyInstanceUIDs(instances: ImportStudyInstanceMetadata[]): string[] {
  return [...new Set(instances.map(instance => instance.studyInstanceUID))];
}

/**
 * Compares parsed StudyInstanceUIDs against studies already imported this session.
 */
export function checkImportStudyDuplicates(
  instances: ImportStudyInstanceMetadata[]
): ImportStudyDuplicateCheckResult {
  const uniqueStudyUIDs = getUniqueStudyInstanceUIDs(instances);
  const isImportedStudyUID = useImportedStudyStore.getState().isImportedStudyUID;

  const duplicateStudyUIDs = uniqueStudyUIDs.filter(studyInstanceUID =>
    isImportedStudyUID(studyInstanceUID)
  );

  if (!duplicateStudyUIDs.length) {
    return { hasDuplicates: false, instances };
  }

  if (duplicateStudyUIDs.length === uniqueStudyUIDs.length) {
    return {
      hasDuplicates: true,
      allDuplicates: true,
      duplicateStudyUIDs,
    };
  }

  const duplicateUIDSet = new Set(duplicateStudyUIDs);

  return {
    hasDuplicates: true,
    allDuplicates: false,
    duplicateStudyUIDs,
    instances: instances.filter(instance => !duplicateUIDSet.has(instance.studyInstanceUID)),
  };
}
